
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.73 7.79c.26.28.683.28.943 0l3.332-3.57a.752.752 0 000-1.01.636.636 0 00-.943 0L5.2 6.275 2.34 3.21a.636.636 0 00-.944 0 .752.752 0 000 1.011l3.332 3.571.003-.002z","fill":"#282E3E"}})])
          )
        }
      }
    